const calculateAspectRatio = (aspectRatio) => {
    if (aspectRatio === 'none')
        return undefined;
    return aspectRatio ? aspectRatio.replace(':', '/') : undefined;
};

export { calculateAspectRatio as default };
